import styled from "styled-components";

const Strikethrough = styled.span`
  display: inline-block;
  position: relative;
  text-decoration: none;

  &:after {
    content: "";
    width: 100%;
    height: 3px;
    background: var(--color-primary);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    opacity: 0.75;
    transform: rotate(-5deg);
    transform-origin: center center;
    border-radius: 10px;
  }
`;

export default Strikethrough;
